import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Panel, PageTitle } from "@/components/ui/Panel";
import { Button } from "@/components/ui/Button";

export function PlaytestOnline() {
  const { id } = useParams();
  const [lobby, setLobby] = useState<any>(null);

  useEffect(() => {
    if (!id) return;
    supabase.from("lobbies").select("*").eq("id", id).maybeSingle().then(({ data }) => setLobby(data));
    const ch = supabase.channel(`online:${id}`).on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "lobbies", filter: `id=eq.${id}` },
      (p) => setLobby(p.new),
    ).subscribe();
    return () => { supabase.removeChannel(ch); };
  }, [id]);

  return (
    <div className="min-h-screen bg-[#13151a] p-4">
      <div className="mx-auto max-w-7xl space-y-4">
        <div className="flex items-center justify-between">
          <PageTitle>Online — {lobby?.name ?? "match"}</PageTitle>
          <Link to="/playtest"><Button variant="secondary">Leave</Button></Link>
        </div>
        <Panel>
          <p className="text-sm text-[#64748b]">
            Online play stub. Game state synced to <span className="font-mono">lobbies.game_state</span>{" "}
            via Supabase realtime. The full board UI lives at <Link className="gm-link" to="/playtest/board">/playtest/board</Link>.
          </p>
        </Panel>
      </div>
    </div>
  );
}
